import { useLocale } from 'next-intl';
import type React from 'react';
import { useMemo } from 'react';

import { MultilineString } from '@/app/(routes)/[locale]/(unauth)/home-components/MultilineString';

interface TranslatedProps {
  fr?: string | null;
  en?: string | null;
  multiline?: boolean;
}
export const Translated: React.FC<TranslatedProps> = ({
  fr,
  en,
  multiline = false,
}) => {
  const locale = useLocale();
  const value = useMemo(() => {
    if (locale === 'en' && !!en) return en;
    return fr;
  }, [locale, en, fr]);

  return multiline ? <MultilineString text={value || ''} /> : value;
};
